module.exports = __webpack_public_path__ + "static/media/udemy.65365355.webp";